import { render } from "./DeleteChangeset.vue?vue&type=template&id=72c2beaf&scoped=true&ts=true"
import script from "./DeleteChangeset.vue?vue&type=script&lang=ts"
export * from "./DeleteChangeset.vue?vue&type=script&lang=ts"

import "./DeleteChangeset.vue?vue&type=style&index=0&id=72c2beaf&scoped=true&lang=css"
import "./DeleteChangeset.vue?vue&type=style&index=1&id=72c2beaf&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c2beaf"]])

export default __exports__